<template>
  <section id="home" class="relative min-h-screen overflow-hidden">
    <!-- Background Images Slider with Text -->
    <div v-for="(slide, index) in slides" :key="'slide-' + index"
         :class="['absolute inset-0 min-h-screen transition-opacity duration-1000', currentSlide === index ? 'opacity-100' : 'opacity-0']">
      <div class="absolute inset-0 bg-black/60"></div>
      <img :src="slide.image" :alt="slide.title" :loading="index === 0 ? 'eager' : 'lazy'" class="w-full h-full min-h-screen object-cover object-center">
      <!-- Content for each slide -->
      <div class="absolute inset-0 z-10 flex items-center py-20 px-6 sm:px-8 lg:px-12">
        <div class="container mx-auto max-w-7xl">
          <div class="max-w-2xl">
            <!-- Dynamic Heading -->
            <h1 class="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 animate-fade-in leading-tight">
              {{ slide.title }}
            </h1>

            <!-- Dynamic Subheading -->
            <p class="text-lg sm:text-xl md:text-2xl text-white/95 mb-10 animate-fade-in-delay leading-relaxed">
              {{ slide.subtitle }}
            </p>

            <!-- CTA Buttons -->
            <div class="flex flex-col sm:flex-row gap-4 animate-fade-in-delay-2">
              <a href="https://docs.google.com/forms/d/e/1FAIpQLSfFWo4Kbs87MZuRUMjLMV9fLjF7lfOCwzbFJ_wenR6yuEqAPQ/viewform" target="_blank" rel="noopener noreferrer">
                <Button size="lg" class="bg-primary hover:bg-accent text-white px-8 py-4 text-lg font-semibold shadow-xl hover:shadow-2xl transition-all duration-300 w-full sm:w-auto">
                  Get Involved
                </Button>
              </a>
              <Button @click="$router.push('/about')" size="lg" class="bg-primary hover:bg-accent text-white px-8 py-4 text-lg font-semibold shadow-xl hover:shadow-2xl transition-all duration-300 w-full sm:w-auto">
                Learn More
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Scroll Indicator -->
    <div class="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-20 animate-bounce">
      <svg class="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
      </svg>
    </div>
  </section>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import { Button } from '@/components/ui/button'

@Options({
  components: { Button },
  data() {
    return {
      currentSlide: 0,
      slides: [
        {
          image: 'https://res.cloudinary.com/du9bmbcpo/image/upload/v1763584238/homepage1_wrbb2k.jpg',
          title: 'SAFARI STRIVES',
          subtitle: 'Every Person, Every Opportunity'
        },
        {
          image: 'https://res.cloudinary.com/du9bmbcpo/image/upload/v1763584235/homepage3_soyb66.jpg',
          title: 'TechStyle Hub',
          subtitle: 'Profitable businesses that reinvest in communities'
        },
        {
          image: 'https://res.cloudinary.com/du9bmbcpo/image/upload/v1763585261/000A8788_vh8pim.jpg',
          title: 'Dignity',
          subtitle: 'Empowering individuals with respect and independence'
        },
        {
          image: '/images/bgsliderimages/b1cff818-d81a-4635-80f1-90dce04e1feb.jpg',
          title: 'Ecosystem',
          subtitle: 'Self-funding ecosystem driving sustainable growth'
        }
      ],
      slideInterval: null as any
    }
  },
  mounted() {
    this.startSlideshow()
  },
  unmounted() {
    if (this.slideInterval) clearInterval(this.slideInterval)
  },
  methods: {
    startSlideshow() {
      this.slideInterval = setInterval(() => {
        this.currentSlide = (this.currentSlide + 1) % this.slides.length
      }, 6000)
    }
  }
})
export default class HeroSection extends Vue {}
</script>

<style scoped>
@keyframes fade-in {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.animate-fade-in {
  animation: fade-in 1s ease-out;
}

.animate-fade-in-delay {
  animation: fade-in 1s ease-out 0.3s both;
}

.animate-fade-in-delay-2 {
  animation: fade-in 1s ease-out 0.6s both;
}

.animate-fade-in-delay-3 {
  animation: fade-in 1s ease-out 0.9s both;
}
</style>
